import React from 'react';
import {Button, Modal, Select} from 'antd';
import {ARCHIMATE_VIEWPOINT_MENU_OPTIONS} from '@/types/model/archimateViewpoint.types';

const SORTED_VIEWPOINT_OPTIONS = [...ARCHIMATE_VIEWPOINT_MENU_OPTIONS].sort((a, b) =>
	String(a.label ?? '').localeCompare(String(b.label ?? ''), 'en', {sensitivity: 'base'})
);

export default function ArchiX6ViewpointModal({
	open,
	initialValue,
	activeViewLabel,
	onApply,
	onCancel,
}) {
	const [draft, setDraft] = React.useState(null);

	React.useEffect(() => {
		if (!open) return;
		setDraft(initialValue ?? null);
	}, [open, initialValue]);

	return (
		<Modal
			title="Viewpoint"
			open={open}
			onCancel={onCancel}
			footer={
				<div style={{display: 'flex', justifyContent: 'flex-end', gap: 8}}>
					<Button onClick={onCancel}>Отмена</Button>
					<Button type="primary" onClick={() => onApply?.(draft)}>
						Применить
					</Button>
				</div>
			}
			width={520}
			destroyOnHidden
			styles={{body: {paddingTop: 4}}}
		>
			<div className="archi-x6-viewpoint-modal-body">
				<div
					style={{
						fontSize: 12,
						color: 'rgba(0,0,0,0.45)',
						marginBottom: 12,
					}}
				>
					Стандартные значения ArchiMate 3 (ViewpointsEnum). Диаграмма:{' '}
					<strong>{activeViewLabel || '—'}</strong>
				</div>
				<Select
					showSearch={{
						optionFilterProp: 'label',
						filterOption: (input, option) =>
							String(option?.label ?? '')
								.toLowerCase()
								.includes(String(input).toLowerCase()),
					}}
					allowClear
					placeholder="Не задано"
					style={{width: '100%'}}
					styles={{
						popup: {
							minWidth: 360,
						},
					}}
					options={SORTED_VIEWPOINT_OPTIONS}
					value={draft ?? undefined}
					onChange={v => setDraft(v ?? null)}
					listHeight={320}
					popupMatchSelectWidth={false}
					getPopupContainer={() => document.body}
				/>
			</div>
		</Modal>
	);
}
